module.exports = __webpack_public_path__ + "img/freespin_multiplier.066b12bf.png";